import Cookie from 'js-cookie';
import isPresent from './is_present';

export default function setCookieValue(name, value) {
  if (isPresent(value)) {
    Cookie.set(name, value, {expires: 999, path: '/'});
  } else {
    Cookie.remove(name, {expires: 999, path: '/'});
  }
}